/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessPermission,
    BusinessPermissionFromJSON,
    BusinessPermissionFromJSONTyped,
    BusinessPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface BusinessUser
 */
export interface BusinessUser {
    /**
     * 
     * @type {string}
     * @memberof BusinessUser
     */
    user: string;
    /**
     * 
     * @type {Array<BusinessPermission>}
     * @memberof BusinessUser
     */
    permissions: Array<BusinessPermission>;
}

export function BusinessUserFromJSON(json: any): BusinessUser {
    return BusinessUserFromJSONTyped(json, false);
}

export function BusinessUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'permissions': ((json['permissions'] as Array<any>).map(BusinessPermissionFromJSON)),
    };
}

export function BusinessUserToJSON(value?: BusinessUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'permissions': ((value.permissions as Array<any>).map(BusinessPermissionToJSON)),
    };
}


